// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__6Pb8X","label":"styles_label__hHpK1","caption":"styles_caption__RYMKi","description":"styles_description__rDFzq","content":"styles_content__ZUhR_"};